module.exports = __webpack_public_path__ + "img/add-icon.342f2cd9.svg";